import React from 'react'
import {AnyColor} from '@components/common/base/design-system'
import {MenuItemData} from '@components/common/base/menu'
import {MenuItem} from '@components/common/base/menu/menu-item'
import {TablerIcons} from '@components/common/icon-tabler/icon-tabler'

export interface MultiMenuItemProps {
  id: string
  icon?: TablerIcons | React.ReactElement
  iconColor?: AnyColor
  color?: AnyColor
  title: string | React.ReactNode
  onClick?: (e: React.MouseEvent<HTMLElement>) => void
  disabled?: boolean
  items?: MenuItemData[]
  /**
   * Allows to add a full custom sub-menu to the item. It behaves like a normal sub-menu, but can be any react component
   */
  customDropdown?: React.ReactNode | (() => React.ReactNode)
  popupMenu?: boolean
  tooltip?: React.ReactNode
  after?: React.ReactElement
  className?: string
  onHover?: (id: string) => void
  onItemClicked?: () => void
}

export const SharedMultiMenuItem = (props: MultiMenuItemProps) => {
  return <MenuItem {...props} />
}
